<template>
	<div class="cpage" style=" overflow: auto;">

		<div style=" border: 2px solid #c5e3fd; background-color: #fff; height: 99%;">
			<div
				style="width: 200px; height: 80%; float: left; background-color: #f4f7fc; margin-left: 20px; margin-top: 20px; border-radius: 10px;">
				<div :class="['leftitem',tab==0?'itemckd':'']" @click="tab=0">
					<span class="dian">◉ </span>报名信息 <span class="arrow">→</span>
				</div>
				<div :class="['leftitem',tab==1?'itemckd':'']" @click="tab=1">
					<span class="dian">◉ </span>专业考试 <span class="arrow">→</span>
				</div>
				<div :class="['leftitem',tab==2?'itemckd':'']" @click="tab=2">
					<span class="dian">◉ </span>文化考试 <span class="arrow">→</span>
				</div>

			</div>
			<div style="margin-left: 220px;">
				<div v-if="tab==0">


					<div style="width: 80%; margin: 0 auto; padding-top: 50px; position: relative;">
						<div
							style="position: absolute; width: 66%; background-color: #509ffe; height: 2px; left: 16%; top: 68px; z-index: 0;">

						</div>
						<div style="width: 33%; display: inline-block; position: relative; z-index: 1;">
							<div
								style="width: 40px; height: 40px; font-size: 25px; text-align: center; line-height: 40px; color: #fff; background-color: #3277f9; border-radius: 50%; margin: 0 auto;">
								<i class="el-icon-edit"></i>
							</div>
							<div style="text-align: center; color: #509ffe;  padding-top: 10px;">
								填写信息
							</div>
						</div>
						<div style="width: 33%; display: inline-block; position: relative; z-index: 1;">
							<div
								style="width: 40px; height: 40px; font-size: 25px; text-align: center; line-height: 40px; color: #fff;background-color: #3277f9; border-radius: 50%; margin: 0 auto;">
								<i class="el-icon-s-check"></i>
							</div>
							<div  style="text-align: center; color: #509ffe;  padding-top: 10px;" >
								审核中
							</div>


						</div>
						<div style="width: 33%; display: inline-block; position: relative; z-index: 1;">
							<div
								style="width: 40px; height: 40px; font-size: 25px; text-align: center; line-height: 40px;color: #fff; background-color: #ccc; border-radius: 50%; margin: 0 auto;" :style="{backgroundColor:stuForm&&stuForm.status>0?'#509ffe':''}">
								<i class="el-icon-check"></i>
							</div>
							<div style="text-align: center; color: #4d6498;   padding-top: 10px;" :style="{color:stuForm&&stuForm.status>0?'#509ffe':''}">
								审核通过
							</div>

						</div>

					</div>
					<div style="   width: 70%; margin: 0 auto; padding-top: 50px;">
						<div style=" padding: 20px 0; font-size: 18px; font-weight: bold; margin-bottom: 10px;">
							<span class="rowlabel"></span>基本信息
						</div>
						<div style="text-align: center; line-height: 100px; font-weight: bold; color: #007AFF;"
							v-if="!stuForm">
							未报名
						</div>
						<table class="bktable" border="" cellspacing="" cellpadding="" v-if="stuForm">

							<tr>
								<td class="tdlabel" style="width: 100px;">姓名</td>
								<td style="width: 30%;">{{stuForm.stu_name}}</td>
								<td class="tdlabel" style="width: 100px;">性别</td>
								<td style="width: 30%;">{{stuForm.gender==1?'男':'女'}}</td>
							</tr>
							<tr>
								<td class="tdlabel">身份证号</td>
								<td>{{stuForm.identity_card}}</td>
								<td class="tdlabel">出生年月</td>
								<td>{{stuForm.birthday}}</td>
							</tr>
							<tr>
								<td class="tdlabel">民族</td>
								<td>{{stuForm.minzu}}</td>
								<td class="tdlabel">户口性质</td>
								<td>{{stuForm.hkxx}}</td>
							</tr>
							<tr>
								<td class="tdlabel">所在地区</td>
								<td>{{stuForm.graduate_sch_city}}</td>
								<td class="tdlabel">所在学校</td>
								<td>{{stuForm.graduate_schname}}</td>
							</tr>
							<tr>
								<td class="tdlabel">考生来源</td>
								<td>

									<span v-if="stuForm.ly_type==1">应届生（本年度6月份毕业）</span>
									<span v-if="stuForm.ly_type==2">往届生（上一年度毕业生）</span>
									<span v-if="stuForm.ly_type==3">在校生（初一年级）</span>
									<span v-if="stuForm.ly_type==4">在校生（小学五年级）</span>
								</td>
								<td class="tdlabel">收件地址</td>
								<td>{{stuForm.jtzz}}</td>
							</tr>
							<tr>
								<td class="tdlabel">收件人</td>
								<td>{{stuForm.jhr1name}}</td>
								<td class="tdlabel">报考专业</td>
								<td>{{stuForm.major.title}}</td>
							</tr>
							<tr>
								<td class="tdlabel">学制</td>
								<td>{{stuForm.major.item_desc}}</td>
								<td class="tdlabel"></td>
								<td></td>
							</tr>
							<tr>
								<td class="tdlabel">相关附件</td>
								<td colspan="3">
									<div class="imageitem"
										:style="{backgroundImage:'url('+stuForm.otherjson.identity_card1+')'}">
										<img :src="stuForm.otherjson.identity_card1" v-viewer
											style="width: 100%; height: 100%;opacity: 0;" preview />
									</div>
									<div class="imageitem" :style="{backgroundImage:'url('+stuForm.otherjson.dzzj+')'}">
										<img :src="stuForm.otherjson.dzzj" v-viewer
											style="width: 100%; height: 100%;opacity: 0;" preview />

									</div>
									<div class="imageitem"
										:style="{backgroundImage:'url('+stuForm.otherjson.score+')'}">
										<img :src="stuForm.otherjson.score" v-viewer
											style="width: 100%; height: 100%;opacity: 0;" preview />

									</div>
								</td>

							</tr>

						</table>
					</div>

				</div>
				<div v-if="tab==1" style="text-align: center; line-height: 200px;">
					未找到考试信息
				</div>
				<div v-if="tab==2" style="text-align: center; line-height: 200px;">
					未找到考试信息
				</div>


			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Form',

		data() {
			return {
				tab: 0,
				stuForm: null
			}
		},
		mounted() {
			this.getBKinfo()
		},
		methods: {
			getBKinfo() {
				this.$http.post("/api/app_stuinfo", {
					pmid: window.pmid,
					phone: sessionStorage.getItem("phone")
				}).then(res => {
					if (res.data) {
						if (res.data.otherjson) {
							res.data.otherjson = JSON.parse(res.data.otherjson)
						}
						this.stuForm = res.data
					}
				})
			},
		}
	}
</script>

<style scoped="">
	.leftitem {
		line-height: 50px;
		padding: 0 10px;
		cursor: pointer;
	}

	.arrow {
		font-size: 30px;
		float: right;
		line-height: 40px;
		margin-right: 20px;
		display: none;
	}

	.itemckd {
		color: #2e72f7;
	}

	.itemckd .dian {
		color: orangered;
	}

	.itemckd .arrow {
		display: block;
	}

	.rowlabel {
		display: inline-block;
		width: 6px;
		border-radius: 3px;
		height: 22px;
		float: left;
		background: #1283ff;
		vertical-align: middle;
		transform: translateY(2px);
		margin-right: 5px;
	}


	.bktable,
	.bktable tr th,
	.bktable tr td {
		border: 1px solid #c5e3fd;
	}

	.bktable td {
		padding: 10px 0;
	}

	.bktable {
		width: 100%;
		min-height: 25px;
		line-height: 25px;
		text-align: center;
		border-collapse: collapse;
		padding: 2px;
	}

	.tdlabel {
		background-color: #f4f7fc;
	}

	.imageitem {
		display: inline-block;
		vertical-align: top;
		width: 120px;
		height: 120px;
		margin-left: 10px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		cursor: pointer;
	}
</style>
